import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Generic = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.49 145.05c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5-51 1.567-51 3.5 22.834 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.145 139.214c33.775 0 61.155-27.359 61.155-61.107S103.92 17 70.145 17C36.37 17 8.99 44.358 8.99 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M108.733 125.641C98.093 134.601 84.35 140 69.346 140c-10.04 0-19.516-2.418-27.874-6.702-.642-.738-.982-1.507-.982-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill={primary}
        fillOpacity={0.75}
        d="M108.733 125.641C98.093 134.601 84.35 140 69.346 140c-10.04 0-19.516-2.418-27.874-6.702-.642-.738-.982-1.507-.982-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="m57.668 138.937 11.711-3.186c3.098-.843 4.155-4.762 1.913-7.09l-16.687-17.327c-2.286-2.374-6.25-1.296-7.062 1.921l-5.178 20.542a60.79 60.79 0 0 0 15.303 5.14Zm.805-6.832c.3 1.136-.364 2.303-1.483 2.608-1.118.304-2.268-.37-2.568-1.506-.3-1.135.364-2.303 1.483-2.607 1.12-.305 2.268.369 2.568 1.505Zm-6.367-15.901c-1.119.305-1.783 1.472-1.483 2.608l1.628 6.169a2.096 2.096 0 0 0 2.57 1.506c1.117-.305 1.781-1.472 1.481-2.608l-1.628-6.169c-.3-1.136-1.45-1.81-2.568-1.506Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity={0.5}
        fillRule="evenodd"
        d="m57.668 138.937 11.711-3.186c3.098-.843 4.155-4.762 1.913-7.09l-16.687-17.327c-2.286-2.374-6.25-1.296-7.062 1.921l-5.178 20.542a60.79 60.79 0 0 0 15.303 5.14Zm.805-6.832c.3 1.136-.364 2.303-1.483 2.608-1.118.304-2.268-.37-2.568-1.506-.3-1.135.364-2.303 1.483-2.607 1.12-.305 2.268.369 2.568 1.505Zm-6.367-15.901c-1.119.305-1.783 1.472-1.483 2.608l1.628 6.169a2.096 2.096 0 0 0 2.57 1.506c1.117-.305 1.781-1.472 1.481-2.608l-1.628-6.169c-.3-1.136-1.45-1.81-2.568-1.506Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9D9D9"
        d="M56.99 134.713c1.12-.305 1.783-1.472 1.483-2.608-.3-1.136-1.449-1.81-2.568-1.505-1.119.304-1.783 1.472-1.483 2.607.3 1.136 1.45 1.81 2.568 1.506Z"
      />
      <path
        fill={primary}
        fillOpacity={0.5}
        d="M56.99 134.713c1.12-.305 1.783-1.472 1.483-2.608-.3-1.136-1.449-1.81-2.568-1.505-1.119.304-1.783 1.472-1.483 2.607.3 1.136 1.45 1.81 2.568 1.506Z"
      />
      <path
        fill="#D9D9D9"
        d="M56.99 134.713c1.12-.305 1.783-1.472 1.483-2.608-.3-1.136-1.449-1.81-2.568-1.505-1.119.304-1.783 1.472-1.483 2.607.3 1.136 1.45 1.81 2.568 1.506Zm-6.367-15.901c-.3-1.136.364-2.303 1.483-2.608 1.118-.304 2.268.37 2.568 1.506l1.628 6.169c.3 1.136-.364 2.303-1.482 2.608-1.119.304-2.269-.37-2.569-1.506l-1.628-6.169Z"
      />
      <path
        fill={primary}
        fillOpacity={0.5}
        d="M50.623 118.812c-.3-1.136.364-2.303 1.483-2.608 1.118-.304 2.268.37 2.568 1.506l1.628 6.169c.3 1.136-.364 2.303-1.482 2.608-1.119.304-2.269-.37-2.569-1.506l-1.628-6.169Z"
      />
      <path
        fill="#D9D9D9"
        d="M50.623 118.812c-.3-1.136.364-2.303 1.483-2.608 1.118-.304 2.268.37 2.568 1.506l1.628 6.169c.3 1.136-.364 2.303-1.482 2.608-1.119.304-2.269-.37-2.569-1.506l-1.628-6.169Z"
      />
      <path
        fill={primary}
        fillOpacity={0.75}
        fillRule="evenodd"
        d="M110.806 124.85c.28-.248.556-.497.83-.748a.501.501 0 0 0-.316-.868.488.488 0 0 0-.193.03.486.486 0 0 0-.167.101 63.969 63.969 0 0 1-1.646 1.457.51.51 0 0 0-.186.343.51.51 0 0 0 .118.373.495.495 0 0 0 .717.044c.283-.241.564-.485.843-.732Zm3.274-4.556a.497.497 0 0 0-.105.555.495.495 0 0 0 .672.251.492.492 0 0 0 .159-.119 61.377 61.377 0 0 0 4.316-5.089.499.499 0 0 0-.466-.798.503.503 0 0 0-.331.193 60.455 60.455 0 0 1-4.245 5.007Zm-9.417 9.343a.494.494 0 0 0 .21-.321.512.512 0 0 0-.079-.374.504.504 0 0 0-.515-.208.522.522 0 0 0-.18.077 60.106 60.106 0 0 1-3.7 2.336.503.503 0 0 0-.181.684.502.502 0 0 0 .684.181 62.11 62.11 0 0 0 3.761-2.375Zm-5.706 3.46a.501.501 0 0 0-.093-.915.501.501 0 0 0-.378.033c-18.15 9.695-39.99 9.416-57.775-.37a.502.502 0 0 0-.727.577.494.494 0 0 0 .245.299c18.08 9.947 40.277 10.232 58.728.376Zm24.138-25.146a.509.509 0 0 0 .048.554.488.488 0 0 0 .529.168.507.507 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.498.498 0 0 0-.676-.207.5.5 0 0 0-.207.676c9.68 18.145 9.379 39.984-.427 57.775Zm-.639-59.687a.503.503 0 0 0 .684.18.5.5 0 0 0 .181-.683 60.79 60.79 0 0 0-2.374-3.762.5.5 0 1 0-.826.564 60.066 60.066 0 0 1 2.335 3.7Zm-89.689 79.612a.52.52 0 0 0 .37.097.504.504 0 0 0 .428-.564.496.496 0 0 0-.194-.33 60.521 60.521 0 0 1-5.007-4.244.504.504 0 0 0-.35-.117.504.504 0 0 0-.473.5.5.5 0 0 0 .136.344 61.529 61.529 0 0 0 5.09 4.314Zm-8.212-7.484a.497.497 0 0 0 .868-.317.5.5 0 0 0-.13-.359 69.981 69.981 0 0 1-.7-.776C2.45 93.87 4.82 55.582 29.895 33.397c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718c-.218-.256-.438-.51-.661-.763l-.036-.04-.035-.04a61.688 61.688 0 0 0-3.805-3.926.503.503 0 0 0-.064-.073 61.353 61.353 0 0 0-5.091-4.314.48.48 0 0 0-.128-.071 61.001 61.001 0 0 0-7.187-4.653.498.498 0 0 0-.146-.12c-18.08-9.95-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237c-.472.255-.94.516-1.407.785a.498.498 0 0 0-.318.063 61.598 61.598 0 0 0-3.762 2.375.499.499 0 0 0-.194.262 62.244 62.244 0 0 0-4.8 3.673.498.498 0 0 0-.306.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.411 62.411 0 0 0-2.724 2.682.499.499 0 0 0-.29.15 61.682 61.682 0 0 0-4.316 5.09.498.498 0 0 0-.102.308 61.25 61.25 0 0 0-4.513 6.935.499.499 0 0 0-.234.215C6.03 67.068 5.723 89.266 15.564 107.71c.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.048.03.093.055.136a62.01 62.01 0 0 0 2.373 3.763.505.505 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.035.04.008.008c.221.25.443.497.67.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M.99 16h88v85h-88V16Z" />
      <path stroke={primary} d="M.99 16h88v85h-88V16Z" />
      <path fill="#fff" d="M5.98 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.98 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1Zm63 9.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm0 9h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm0 9h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm0 8.999h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm0 9h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm0 9h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.757 21H26.385a.905.905 0 0 0 0 1.81h12.372a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.075 21h-5.281a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.211 21H68.93a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.439 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.104 113.216c7.403 0 13.404-5.996 13.404-13.393S96.507 86.43 89.104 86.43 75.7 92.426 75.7 99.823s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.104 113.217c7.403 0 13.404-5.997 13.404-13.394S96.507 86.43 89.104 86.43 75.7 92.426 75.7 99.823s6.001 13.394 13.404 13.394Zm1.676-18.416a1.676 1.676 0 0 0-3.351 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.676 1.676 0 0 0 3.352 0v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M113.465 7.023h-31a2 2 0 0 0-2 2v8.083h35V9.023a2 2 0 0 0-2-2Z"
      />
      <path
        fill={primary}
        fillOpacity={0.25}
        d="M113.465 7.023h-31a2 2 0 0 0-2 2v8.083h35V9.023a2 2 0 0 0-2-2Z"
      />
      <path fill="#fff" d="M115.465 39.674V17.106h-35v22.568h35Z" />
      <path
        fill={primary}
        fillOpacity={0.25}
        d="M115.465 39.674V17.106h-35v22.568h35Z"
      />
      <path
        fill="#fff"
        d="M115.465 45.023v-5.35h-35v5.35a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2Z"
      />
      <path
        fill={primary}
        fillOpacity={0.25}
        d="M115.465 45.023v-5.35h-35v5.35a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2Z"
      />
      <path
        stroke={primary}
        d="M80.465 45.023v-36m0 36a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2m-35 0v-5.35m35 5.35v-36m0 36v-5.35m0-30.65a2 2 0 0 0-2-2h-31a2 2 0 0 0-2 2m35 0v8.083m-35-8.083v8.083m0 0h35m-35 0v22.568m35-22.568v22.568m-35 0h35"
      />
      <path
        fill={primary}
        d="M88.284 12.521a2.214 2.214 0 1 1-4.427 0 2.214 2.214 0 0 1 4.427 0Z"
      />
      <path
        fill={primary}
        fillRule="evenodd"
        d="M116.132 3.99c-.546-2.243-3.738-2.243-4.284 0a2.2 2.2 0 0 1-3.286 1.362c-1.972-1.202-4.229 1.055-3.028 3.028a2.204 2.204 0 0 1-1.361 3.287c-2.244.545-2.244 3.738 0 4.281a2.206 2.206 0 0 1 1.516 1.298 2.197 2.197 0 0 1-.155 1.99c-1.201 1.972 1.056 4.23 3.028 3.027a2.2 2.2 0 0 1 2.82.448c.226.264.386.577.467.914.545 2.244 3.738 2.244 4.281 0a2.211 2.211 0 0 1 1.299-1.516 2.202 2.202 0 0 1 1.989.154c1.972 1.202 4.229-1.055 3.028-3.027a2.196 2.196 0 0 1 .448-2.82 2.2 2.2 0 0 1 .913-.468c2.244-.545 2.244-3.737 0-4.28a2.208 2.208 0 0 1-1.516-1.299 2.197 2.197 0 0 1 .155-1.99c1.201-1.972-1.056-4.229-3.028-3.027a2.2 2.2 0 0 1-2.82-.448 2.202 2.202 0 0 1-.468-.913l.002-.002Zm-2.142 14.13a4.31 4.31 0 0 0 4.313-4.312 4.312 4.312 0 1 0-4.313 4.312Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        d="M83.857 21.242h19.842v3.066H83.857v-3.066Zm7.713 6.078h19.843v3.066H91.57V27.32Zm-7.713 6.078h19.842v3.065H83.857v-3.065Z"
      />
      <path
        fill="#fff"
        d="M113.99 18.12a4.31 4.31 0 0 0 4.313-4.312 4.312 4.312 0 1 0-4.313 4.312Z"
      />
      <path
        fill={primary}
        fillOpacity={0.25}
        d="M113.99 18.12a4.31 4.31 0 0 0 4.313-4.312 4.312 4.312 0 1 0-4.313 4.312Z"
      />
      <path
        fill={primary}
        d="m110.468 43.353-.27-1.289a.15.15 0 0 1 .204-.195l2.697 1.35a.15.15 0 0 1 0 .27l-2.697 1.349a.15.15 0 0 1-.204-.195l.27-1.29Z"
      />
      <path
        fill="#fff"
        stroke={primary}
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        d="m128.66 79.5 1.32-1.44m0 0c.249.272.592.44.972.44.759 0 1.375-.672 1.375-1.5s-.616-1.5-1.375-1.5-1.375.672-1.375 1.5c0 .414.154.79.403 1.06Zm4.639-.56c0 2.485-1.847 4.5-4.125 4.5-2.279 0-4.125-2.015-4.125-4.5s1.846-4.5 4.125-4.5c2.278 0 4.125 2.015 4.125 4.5Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.104"
          x2="89.104"
          y1="86.43"
          y2="113.217"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Generic;
